// 模組04 營運資訊(IP/專案/合約/廠商)+ 模組05 軟體 — mock 種子
// 專案/合約/廠商仍為 Sprint 2 殼層欄位;IP 已照 WF_v3(2375:30523)擴充(9月交付票 02)。

/**
 * IP 資訊(票 02,對稿 WF_v3):
 *   ip/parentIp(上一層)/mask/gateway/dns/mac/port(IP Port 位,SNMP 自動帶出)/
 *   iface(介面位置)/manager(IP 管理者)/source(SNMP|人工建檔)/keyBusiness(★關鍵業務)
 *   assets    已關聯資產快照(關聯當下由資產帶出,含位置 —— 列表「關聯設備/位置」
 *             由第一筆硬體資產推導,推導在 mock decorate,前端不自己算,ADR-0007)
 *   projects  已關聯專案;vendors 維護廠商(自合約關聯帶出,mock 直接給值)
 *   history   異動歷程(SNMP 探測列=系統自動寫入,不經審核)
 *   pendingAction 審核中的申請型別:create→列表「審核中|單號」/update→「異動中」
 */
/**
 * IP 資訊種子(票 9月交付/16 起照 `DcIpAddress` 契約的**語意**存):
 * - `managerId` → user store(DcCustomer)的 id;`manager_customer_name` 由投影查表帶出
 * - `assets[]` 是**關聯參照** `{ id: mappingId, assetType: "Hardware"|"Rack", assetId }`,
 *   資產明細(名稱/編號/廠牌/位置/管理者)由 hardware／cabinet store 投影時帶出 ——
 *   後端就是這樣(GetAssetMappings 34 鍵全是查出來的),mock 不再存第二份真相(ADR-0007)
 * - `pendingReview`＝SNMP 自動更新待人工確認(「異動中」,ConfirmReview 的對象);
 *   `approvalStatus: "pending"`＝審核單在途(「審核中｜單號」)。9/13 smoke:兩者是兩個欄位
 * - `history[]` 由審核引擎(`mock/approvals.js` appendIpHistory)回寫;`result` 值域照 swagger
 *   `DcIpAddressChangeLogDto.status_text`(已核准(結案)／審核中／已退回／系統自動寫入(不需簽核))
 * - ⚠️ `projects`／`vendors` 是 mock-only 的推算來源:後端列表的 support_project_name／
 *   maintenance_vendor_name 是「由關聯資產所屬專案／合約推算」,DcProject／DcVendor 未到位前
 *   mock 先從這裡取第一筆(待確認清單設計第 10 點)
 */
export const ips = [
  {
    id: 1, ip: "10.20.1.8", parentIp: "10.20.1.1", mask: "255.255.255.0", gateway: "10.20.1.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:B7", port: "Gi1/0/24", iface: "Eth0",
    managerId: 4, source: "SNMP", lastProbedOn: "2026-07-26T03:00:00", approvalStatus: "approved",
    assets: [
      { id: 1, assetType: "Hardware", assetId: 4 }, // SRV-A01-004 應用伺服器(R-A01・台北內湖)
      { id: 2, assetType: "Rack", assetId: 1 },     // R-A01
    ],
    projects: [
      { code: "PRJ-2026-001", name: "2026核心機房汰換案", manager: "林承翰", startDate: "2025-09-01", endDate: "2026-08-31" },
    ],
    vendors: ["宏益科技", "設備廠商"],
    history: [
      { at: "2026-08-05 14:22", by: "林承翰（EMP-0031）", kind: "異動",
        text: "關聯設定：新增關聯硬體 SRV-A01-004（應用伺服器），主要關聯不變",
        docNo: "RQ-20260805-012", result: "已核准(結案)" },
      { at: "2026-07-26 03:00", by: "系統", kind: "更新",
        text: "更新 IP Port 位：Gi1/0/23 → Gi1/0/24（探測值自動更新；與人工值不一致列入一致性校對差異報表）",
        docNo: null, result: "系統自動寫入(不需簽核)" },
      { at: "2026-06-12 10:02", by: "林承翰（EMP-0031）", kind: "新增",
        text: "建立 IP 10.20.1.8（關聯硬體 SRV-A01-004・主要）",
        docNo: "RQ-20260612-007", result: "已核准(結案)" },
    ],
  },
  {
    // SNMP 探測改了值、等人確認 → 「異動中」(不是審核單;列不凍結,可 ConfirmReview)
    id: 2, ip: "10.20.1.9", parentIp: "10.20.1.1", mask: "255.255.255.0", gateway: "10.20.1.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:B8", port: "Gi1/0/25", iface: "Eth1",
    managerId: 4, source: "SNMP", lastProbedOn: "2026-09-12T03:00:00", pendingReview: true, approvalStatus: "approved",
    assets: [{ id: 3, assetType: "Hardware", assetId: 2 }], // SRV-A01-002 資料庫主機
    projects: [
      { code: "PRJ-2026-001", name: "2026核心機房汰換案", manager: "林承翰", startDate: "2025-09-01", endDate: "2026-08-31" },
    ],
    vendors: ["宏益科技"],
    history: [
      { at: "2026-09-12 03:00", by: "系統", kind: "更新",
        text: "更新 Mac 資訊：00:1B:44:11:3A:B0 → 00:1B:44:11:3A:B8（探測值自動更新，待人工確認）",
        docNo: null, result: "系統自動寫入(不需簽核)" },
    ],
  },
  {
    id: 3, ip: "10.20.2.30", parentIp: "10.20.2.1", mask: "255.255.255.0", gateway: "10.20.2.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:C2", port: "Gi2/0/08", iface: "Eth0",
    managerId: 2, source: "SNMP", lastProbedOn: "2026-09-01T03:00:00", approvalStatus: "approved",
    assets: [{ id: 4, assetType: "Hardware", assetId: 6 }], // SRV-B02-002 防火牆主機(R-A02)
    projects: [],
    vendors: ["設備廠商"],
    history: [],
  },
  {
    // 掛在桃園青埔機房的機櫃上 —— 列表「機房篩選」要能只篩出這一筆
    id: 4, ip: "10.10.32.15", parentIp: "10.10.32.1", mask: "255.255.255.0", gateway: "10.10.32.254",
    dns: "10.10.30.5", mac: "00:1B:44:22:5C:01", port: "", iface: "Eth0",
    managerId: 34, source: "人工建檔", lastProbedOn: null, approvalStatus: "approved",
    assets: [{ id: 5, assetType: "Rack", assetId: 3 }], // R-B01(桃園青埔機房)
    projects: [
      { code: "PRJ-2026-004", name: "異地備援建置案", manager: "張家豪", startDate: "2025-11-01", endDate: "2026-12-31" },
    ],
    vendors: ["創唯科技"],
    history: [],
  },
  {
    id: 5, ip: "172.16.0.6", parentIp: "172.16.0.1", mask: "255.255.0.0", gateway: "172.16.0.254",
    dns: "", mac: "", port: "", iface: "",
    managerId: 5, source: "人工建檔", lastProbedOn: null, approvalStatus: "approved",
    assets: [], projects: [], vendors: [], history: [],
  },
  {
    id: 6, ip: "192.168.50.11", parentIp: "192.168.50.1", mask: "255.255.255.0", gateway: "192.168.50.254",
    dns: "", mac: "", port: "", iface: "Eth2",
    managerId: 34, source: "人工建檔", lastProbedOn: null, approvalStatus: "pending",
    pendingAction: "create", docNo: "RQ-20260609-003",
    assets: [], projects: [], vendors: [], history: [],
  },
  // 2026-10-20 SIT 樣本（DcIpAddress/GetById/1 原樣，個資已換假）
  // IP 與 mock 1 號相同(SIT 本身也有兩筆 10.20.1.8);ip_port／data_source／last_probed_on 為 null 照抄。
  // 管理者 SIT 是 1「SysAdmin」→ 指到 mock 使用者 1(王大器),名稱由投影查 user store 帶出。
  {
    id: 7, ip: "10.20.1.8", parentIp: "10.20.1.1", mask: "255.255.255.0", gateway: "10.20.1.254",
    dns: "10.20.1.10", mac: "00:1B:44:11:3A:B7", port: null, iface: "Eth0",
    managerId: 1, source: null, lastProbedOn: null, pendingReview: false, approvalStatus: "approved",
    assets: [], projects: [], vendors: [], history: [],
    createdOn: "2026-09-13T12:45:23.475005+08:00", updatedOn: "2026-09-16T20:33:33.733243+08:00",
  },
];

export const projects = [
  { id: 1, name: "核心網路汰換 2026", owner: "林承翰（資訊處）", startDate: "2026-01-15", endDate: "2026-11-30", status: "進行中", approvalStatus: "approved" },
  { id: 2, name: "機房整併專案", owner: "張家豪（維運部）", startDate: "2026-03-01", endDate: "2026-08-15", status: "進行中", approvalStatus: "approved" },
];

/**
 * 合約資訊(票 04,對稿 WF_v3 2375:32205):
 *   code/name/manager/startDate/endDate/years/cycle(維護週期)/sla(服務等級)/amount/
 *   vendorName(服務廠商)/replyHours/arriveHours/fixHours(三時點)/contact/phone{...}/email/
 *   content(合約內容/用途)/mainChain(主要關聯合約:主約鏈)/linked(已關聯合約)/
 *   assets(資產關聯快照,同 IP)/maintenance(維護歷程月曆事件)/history(異動歷程)
 * 狀態(正常/剩N天/已逾期N天)由 endDate 於顯示時推導,不存欄位。
 */
/**
 * 合約種子(票 9月交付/33 起照 `DcContract` 契約的**語意**存;寫入側仍走舊 REST,所以文字欄照留):
 * - `managerId` → user store;`vendorName` → vendor store 查 id(DcVendor 未到,mock 自己查);
 *   `sla`／`cycle` 文字 → `db/contractLookups` 查 id
 * - `mainContractId`／`relations[]`(`{id, relatedId, type: Predecessor|Successor, isPrimary}`)取代原本存名字的
 *   mainChain／linked:後端只有 GetRelations 一種關聯、關聯只由上案(primary_related_contract_id)建立
 * - `assets[]` 是 `{id, assetType: Hardware|Rack|Software, assetId}` 參照(合約可掛三種),明細投影時查資產 store
 * - `maintenance[]` 照 `DcContractMaintenanceRecordDto` 語意:`{id, sequence, scheduledOn, statusId(0 未完成/1 已完成), description}`
 * - `history[]` result 值域照 swagger `DcContractChangeLogDto.status_text`(已核准(結案)／審核中／已退回／已取消)
 * - 4 號(消防)刻意沒有上案:「第一張合約 primary_related_contract_id 填什麼」是待確認清單的問題,mock 先允許 null
 */
// 「剩 N 天」示範列的結束日要跟著今天走:寫死日期一過,列表就從「剩 N 天」變「已逾期」,
// RegistryPages.test.js 的狀態斷言會隨日曆失效(2026-10-17 實際發生:寫死 2026-10-05)。
const daysFromToday = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const contracts = [
  {
    id: 1, code: "CT-2026-031", name: "核心機房設備維護合約", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: "2026-12-31", years: 1, cycle: "季維護", sla: "7*24",
    amount: 2480000, vendorName: "宏益科技",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw",
    content: "核心機房伺服器、交換器與防火牆之年度維護,含季度到場保養與零件更換。",
    mainContractId: 4, mainContract: "CT-2025-090",
    relations: [
      { id: 1, relatedId: 4, type: "Predecessor", isPrimary: true },  // 上案:消防設備檢測合約(主約)
      { id: 2, relatedId: 2, type: "Successor", isPrimary: false },   // 下一案:空調
      { id: 3, relatedId: 3, type: "Successor", isPrimary: false },   // 下一案:UPS
    ],
    assets: [
      { id: 1, assetType: "Hardware", assetId: 4 }, // SRV-A01-004 應用伺服器
      { id: 2, assetType: "Rack", assetId: 1 },     // R-A01
    ],
    maintenance: [
      // 已完成的那次留一份附件:沒有任何一筆帶附件的話,`attachments[]` 的形狀永遠沒被驗到(票 39)
      { id: 1, sequence: 1, scheduledOn: "2026-08-13T09:00:00", statusId: 1, description: "季度到場保養(第 1 次)",
        // download_id 是整數(契約如此,DownloadMaintenanceAttachment 的路徑參數也是 int32)
        attachments: [{ downloadId: 9001, fileName: "20260813_保養報告.pdf", downloadUrl: "#/mock/attachment/9001" }] },
      { id: 2, sequence: 2, scheduledOn: "2026-08-21T09:00:00", statusId: 0, description: "季度到場保養(第 2 次)" },
    ],
    history: [
      { at: "2026-08-10 10:12", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "合約金額（附件缺報價單，補件後重送）", docNo: "RQ-20260810-006", result: "已退回" },
      { at: "2026-07-30 14:50", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "維護範圍：新增 備援資料庫（到期歷起算沿用・前 300 天）", docNo: "RQ-20260730-011", result: "已核准(結案)" },
      { at: "2026-06-03 13:26", by: "吳佩珊（EMP-0121）", kind: "異動",
        text: "關聯合約：新增下一案 CT-2026-045（空調設備年度維護合約）", docNo: "RQ-20260603-005", result: "已核准(結案)" },
      { at: "2026-04-08 09:00", by: "吳佩珊（EMP-0121）", kind: "新增",
        text: "建立合約 CT-2026-031（維護廠商：宏益科技股份有限公司）", docNo: "RQ-20260408-001", result: "已核准(結案)" },
    ],
    approvalStatus: "approved",
  },
  {
    id: 2, code: "CT-2026-045", mainContractId: 1, mainContract: "CT-2026-031", name: "空調設備年度維護合約", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: daysFromToday(30), years: 1, cycle: "年維護", sla: "5*8",
    amount: 2480000, vendorName: "宏益科技",
    replyHours: 2, arriveHours: 8, fixHours: 48,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 11, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  {
    id: 3, code: "CT-2026-052", mainContractId: 1, mainContract: "CT-2026-031", name: "UPS 不斷電系統維護合約", managerId: 4, manager: "林承翰",
    startDate: "2024-01-01", endDate: "2027-12-31", years: 3, cycle: "月維護", sla: "5*10",
    amount: 3600000, vendorName: "宏益科技",
    replyHours: 2, arriveHours: 6, fixHours: 36,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 12, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  {
    // 第一張合約:沒有上案(待確認清單:primary_related_contract_id 必填時第一張怎麼填)
    id: 4, code: "CT-2025-090", mainContractId: null, mainContract: "", name: "消防設備檢測合約", managerId: 4, manager: "林承翰",
    startDate: "2023-07-01", endDate: "2026-08-04", years: 3, cycle: "半年維護", sla: "5*10",
    amount: 960000, vendorName: "宏益科技",
    replyHours: 4, arriveHours: 24, fixHours: 72,
    contact: "王大明", phone: { country: "+886", area: "02", number: "22222222", ext: "" },
    email: "email@com.tw", content: "",
    relations: [{ id: 13, relatedId: 1, type: "Successor", isPrimary: false }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
  },
  // 舊種子保留:廠商刪除阻擋(創唯科技仍有合約)與既有測試對這兩列有依賴
  { id: 5, code: "CT-2026-001", mainContractId: 1, mainContract: "CT-2026-031", name: "機房維運服務合約 2026", managerId: 4, manager: "林承翰",
    startDate: "2026-01-01", endDate: "2026-10-15", years: 1, cycle: "季維護", sla: "7*24",
    amount: 1200000, vendorName: "創唯科技",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "王經理", phone: { country: "+886", area: "02", number: "23456789", ext: "" },
    email: "service@trueway.com.tw", content: "",
    relations: [{ id: 14, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "approved" },
  {
    id: 6, code: "CT-2026-060", mainContractId: 1, mainContract: "CT-2026-031", name: "網路設備保固合約", managerId: 34, manager: "李宜潔",
    startDate: "2026-04-01", endDate: "2027-03-31", years: 1, cycle: "季維護", sla: "7*24",
    amount: 680000, vendorName: "神通資訊",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "李工程師", phone: { country: "+886", area: "02", number: "87654321", ext: "" },
    email: "svc@mitac.com.tw", content: "",
    relations: [{ id: 15, relatedId: 1, type: "Predecessor", isPrimary: true }],
    assets: [], maintenance: [], history: [],
    approvalStatus: "pending", pendingAction: "create", docNo: "RQ-20260609-003",
  },
  // 2026-10-20 SIT 樣本（DcContract/GetById/2 原樣，個資已換假）
  // 合約編號／名稱與 mock 1 號相同(SIT 本身也有兩筆 CT-2026-031);起訖日帶時間、金額 0、幣別 NTD、說明空字串照抄,
  // amount_text 存後端原字 "NT$0"(SIT 無空白,mock 格式化是 "NT$ 0")。
  // 換掉的:管理者 SIT 1「SysAdmin」→ mock 使用者 1(王大器);聯絡人／電話／分機／email 換假。
  // 廠商:SIT vendor 1「弘毅科技股份有限公司」mock 廠商主檔沒有 → 對到既有 3 號「宏益科技」(vendor_id 由名稱查表得 3)。
  {
    id: 7, code: "CT-2026-031", name: "核心機房設備維護合約", managerId: 1, manager: "王大器",
    startDate: "2026-01-01T05:37:39.748", endDate: "2026-12-31T05:37:39.748", years: 1, cycle: "月維護", sla: "5*8",
    amount: 0, amountText: "NT$0", currency: "NTD", vendorName: "宏益科技",
    replyHours: 1, arriveHours: 4, fixHours: 24,
    contact: "陳志偉", phone: { country: "+886", area: "02", number: "27005566", ext: "315" },
    email: "contact@example.com.tw", content: "",
    mainContractId: null, mainContract: "",
    relations: [], assets: [], maintenance: [], history: [],
    approvalStatus: "approved",
    createdOn: "2026-09-13T05:45:20.609556", updatedOn: "2026-09-13T05:55:03.784463",
  },
];

export const vendors = [
  { id: 1, name: "創唯科技", type: "系統整合", rating: "A", contact: "王經理", phone: "02-2345-6789", approvalStatus: "approved" },
  { id: 2, name: "神通資訊", type: "硬體維修", rating: "B", contact: "李工程師", phone: "02-8765-4321", approvalStatus: "approved" },
  // 合約種子四份都掛在這家(票 33 起合約列表的 vendor_id 由這裡查表,以前是孤兒名稱)
  {
    id: 3, name: "宏益科技", type: "維運", rating: "A", contact: "陳經理", phone: "02-2222-3333", approvalStatus: "approved",
    // DcVendorEngineerDto（SIT 唯一一筆兩組都是空陣列 —— 這裡各種一筆，讓形狀守衛比對得到）
    technicalEngineers: [{ id: 1, name: "林工程師", title: "資深工程師", phone: "02-2222-3334", email: "eng1@example.com", mobile: "0912000001" }],
    onSiteEngineers: [{ id: 2, name: "黃工程師", title: "駐點工程師", phone: "02-2222-3335", email: "eng2@example.com", mobile: "0912000002" }],
  },
  // SIT 樣本（DcVendor/GetById/1，2026-10-20 唯讀錄）：類型／評等沒設定（0＋null）、簡稱 null、沒有承做以外的電話。
  // 名稱、聯絡人、email 換成假的；其餘照原值。
  {
    id: 4, name: "測試廠商股份有限公司", type: null, rating: null, contact: "測試聯絡人", phone: "987654321",
    taxId: "12345678", address: "test", serviceScope: "test", email: "vendor@example.com", managerId: 1,
    createdOn: "2026-09-13T12:45:23.475005+08:00", approvalStatus: "approved",
  },
];

// 軟體資訊（DCK-05 軟體，Figma v2 `2128:25038`）。部署設備(`mock_only.deployedHardwareIds`)指向 db/assets.js 的硬體 ——
// 機房/機櫃/U 位由硬體那邊推導,不在這裡再存一份。
// 軟體種子 = **後端 DTO 形狀**(swagger DcSoftwareDto ∪ DcSoftwareListItemDto 存得住的鍵;票 poc-20260922/07)。
//   後端算得出來的不存(EOS／EOL 風險等級、管理者、類別名稱、部署設備列),回傳時才算 —— 見 mock/softwareRecord.js。
//   後端沒有的(弱掃／滲透明細與上傳檔、IP 分頁、部署關聯、審核單號)收在 `mock_only`,API 一律不吐。
export const software = [
  {
    id: 1,
    asset_no: "SW-0001",
    host_name: "VMware vSphere",
    software_no: "VS8-0001-AAAA-1111",
    version: "8.0 U2",
    is_key_business: false,
    business_category_id: 1,
    asset_category_id: 3,
    property_no: "PRP-2024-0101",
    brand: "VMware",
    model: "vSphere Enterprise Plus",
    environment_id: 1,
    environment_name: "營運",
    active: true,
    remark: "虛擬化平台,全機房共用。",
    eos_date: "2027-10-31T00:00:00",
    eol_date: "2029-10-31T00:00:00",
    cve_date: null,
    cve_risk_level: null,
    cve_count: 0,
    kev_date: null,
    kev_risk_level: null,
    kev_count: 0,
    vulnerability_hits: [],
    vulnerability_scan_date: null,
    next_vulnerability_scan_date: null,
    penetration_test_date: null,
    next_penetration_test_date: null,
    mock_only: {
      scanFiles: [],
      scanRows: [],
      pentestFiles: [],
      pentestRows: [],
      deployedHardwareIds: [1, 4],
      ip: "10.10.32.15",
      parentIp: "10.10.32.1",
      ports: ["443/tcp", "902/tcp"],
      approvalStatus: "approved",
    },
  },
  // 四種風險都踩到的那一筆;命中清單抄設計稿 `2198:58231` 的兩列(DcAssetVulnerabilityHitDto 形狀),弱掃／滲透明細在 mock_only
  {
    id: 2,
    asset_no: "SW-0012",
    host_name: "Windows Server",
    software_no: "WS19-DC-2222-3333",
    version: "2019 Std",
    is_key_business: true,
    business_category_id: 1,
    asset_category_id: 3,
    property_no: "PRP-2024-0112",
    brand: "Microsoft",
    model: "Windows Server Datacenter",
    environment_id: 1,
    environment_name: "營運",
    active: true,
    remark: "",
    eos_date: "2026-06-30T00:00:00",
    eol_date: "2026-12-31T00:00:00",
    cve_date: "2026-06-30T00:00:00",
    cve_risk_level: "嚴重",
    cve_count: 2,
    kev_date: "2026-12-31T00:00:00",
    kev_risk_level: "高",
    kev_count: 1,
    vulnerability_hits: [
      {
        cve_id: "CVE-2026-11884",
        severity: "嚴重",
        cvss_base_score: 9.1,
        category: "軟體(Windows Server)",
        is_kev: false,
        kev_date_added_utc: null,
        published_on_utc: "2026-05-14T00:00:00",
        is_platform_level: false,
        description: "Windows Server 遠端桌面服務遠端執行程式碼弱點",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2026-11884",
      },
      {
        cve_id: "CVE-2026-10233",
        severity: "高",
        cvss_base_score: 8.1,
        category: "軟體(Windows Server)",
        is_kev: true,
        kev_date_added_utc: "2026-06-10T00:00:00",
        published_on_utc: "2026-03-02T00:00:00",
        is_platform_level: false,
        description: "Windows Server SMB 用戶端權限提升弱點",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2026-10233",
      },
    ],
    vulnerability_scan_date: "2026-05-14T00:00:00",
    next_vulnerability_scan_date: "2026-11-14T00:00:00",
    penetration_test_date: "2026-04-02T00:00:00",
    next_penetration_test_date: "2026-10-02T00:00:00",
    mock_only: {
      scanFiles: [],
      scanRows: [
        {
          version: "2019 Std",
          patched: "Y",
          risk: "中",
          fileDate: "2025/12/3",
          note: "已套用 5 月累積更新",
        },
        {
          version: "2016 Std",
          patched: "N",
          risk: "高",
          fileDate: "2025/12/3",
          note: "",
        },
      ],
      pentestFiles: [],
      pentestRows: [
        {
          version: "2019 Std",
          patched: "N",
          risk: "低",
          fileDate: "2025/12/3",
          note: "",
        },
      ],
      deployedHardwareIds: [2, 5, 6],
      ip: "10.10.32.16",
      parentIp: "10.10.32.1",
      ports: ["3389/tcp"],
      approvalStatus: "approved",
    },
  },
  {
    id: 3,
    asset_no: "SW-0023",
    host_name: "Red Hat Enterprise Linux",
    software_no: "RHEL94-4444-5555",
    version: "9.4",
    is_key_business: false,
    business_category_id: 2,
    asset_category_id: 3,
    property_no: "",
    brand: "Red Hat",
    model: "RHEL Server",
    environment_id: 2,
    environment_name: "測試",
    active: true,
    remark: "",
    eos_date: "2030-06-30T00:00:00",
    eol_date: "2030-06-30T00:00:00",
    cve_date: null,
    cve_risk_level: null,
    cve_count: 0,
    kev_date: null,
    kev_risk_level: null,
    kev_count: 0,
    vulnerability_hits: [],
    vulnerability_scan_date: null,
    next_vulnerability_scan_date: null,
    penetration_test_date: null,
    next_penetration_test_date: null,
    mock_only: {
      scanFiles: [],
      scanRows: [],
      pentestFiles: [],
      pentestRows: [],
      deployedHardwareIds: [3],
      ip: "10.10.33.20",
      parentIp: "",
      ports: [],
      approvalStatus: "approved",
    },
  },
  // 還沒部署到任何設備 —— 列表的「部署設備數 0 台」與展開後的空狀態要有樣本
  {
    id: 4,
    asset_no: "SW-0031",
    host_name: "Oracle Database",
    software_no: "ORA19C-6666-7777",
    version: "19c",
    is_key_business: false,
    business_category_id: 3,
    asset_category_id: 4,
    property_no: "",
    brand: "Oracle",
    model: "Database Enterprise",
    environment_id: 3,
    environment_name: "開發",
    active: true,
    remark: "採購完成,尚未安裝。",
    eos_date: null,
    eol_date: null,
    cve_date: null,
    cve_risk_level: null,
    cve_count: 0,
    kev_date: null,
    kev_risk_level: null,
    kev_count: 0,
    vulnerability_hits: [],
    vulnerability_scan_date: null,
    next_vulnerability_scan_date: null,
    penetration_test_date: null,
    next_penetration_test_date: null,
    mock_only: {
      scanFiles: [],
      scanRows: [],
      pentestFiles: [],
      pentestRows: [],
      status: "閒置",
      deployedHardwareIds: [],
      ip: "10.10.34.10",
      parentIp: "",
      ports: [],
      approvalStatus: "approved",
    },
  },
  // 審核中 —— 列表要顯示「審核中｜單號」;營運環境「DMZ區域」不在 Common 主檔,id 0 只留名稱
  {
    id: 5,
    asset_no: "SW-0044",
    host_name: "Nginx",
    software_no: "NGXP-R32-8888",
    version: "R32",
    is_key_business: false,
    business_category_id: 1,
    asset_category_id: 3,
    property_no: "",
    brand: "F5",
    model: "NGINX Plus",
    environment_id: 0,
    environment_name: "DMZ區域",
    active: true,
    remark: "",
    eos_date: null,
    eol_date: null,
    cve_date: null,
    cve_risk_level: null,
    cve_count: 0,
    kev_date: null,
    kev_risk_level: null,
    kev_count: 0,
    vulnerability_hits: [],
    vulnerability_scan_date: null,
    next_vulnerability_scan_date: null,
    penetration_test_date: null,
    next_penetration_test_date: null,
    mock_only: {
      scanFiles: [],
      scanRows: [],
      pentestFiles: [],
      pentestRows: [],
      deployedHardwareIds: [1],
      ip: "10.10.35.5",
      parentIp: "",
      ports: ["80/tcp", "443/tcp"],
      docNo: "SW-2026-0044",
      approvalStatus: "pending",
    },
  },
  // 2026-10-20 SIT 樣本（DcSoftware/GetById/2031 原樣，個資已換假）
  // 7-Zip 21.06：SIT 沒有廠牌／型號(brand_id 0／null),所以不需對主檔;營運環境 0／null、類別 0、
  // 沒有管理者(0／null),無個資。命中 CVE-2025-0411(高,KEV 2025-02-06)照抄。
  // cve_risk_level／kev_risk_level／cve_count／kev_count 是列表列才有的鍵,GetById 沒有 → 依命中那一筆推(高／1)。
  {
    id: 6,
    business_category_id: 0,
    is_key_business: false,
    property_no: null,
    host_name: "7-Zip 21.06 (x64)",
    asset_category_id: 0,
    asset_no: null,
    brand_id: 0,
    brand: null,
    model_id: 0,
    model: null,
    software_no: "7-Zip 21.06 (x64)",
    version: "21.06",
    environment_id: 0,
    environment_name: null,
    remark: null,
    vendor_name: null,
    deployed_date: null,
    purchase_amount: 0,
    currency_code: null,
    active: true,
    created_on: "2026-09-29T10:18:45.133877+08:00",
    updated_on: "2026-10-20T18:17:03.186534+08:00",
    eos_date: null,
    eol_date: null,
    end_of_sale_date: null,
    latest_version: null,
    cpe: null,
    cve_date: "2025-02-06T00:00:00",
    kev_date: "2025-02-06T00:00:00",
    vulnerability_hits: [
      {
        cve_id: "CVE-2025-0411",
        severity: "高",
        cvss_base_score: 7.0,
        category: "軟體/韌體",
        is_kev: true,
        kev_date_added_utc: "2025-02-06T00:00:00",
        published_on_utc: "2025-02-06T00:00:00",
        is_platform_level: true,
        description: "7-Zip contains a protection mechanism failure vulnerability that allows remote attackers to bypass the Mark-of-the-Web security feature to execute arbitrary code in the context of the current user.",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2025-0411",
      },
    ],
    vulnerability_scan_date: null,
    vulnerability_scan_file_url: null,
    next_vulnerability_scan_date: null,
    penetration_test_date: null,
    penetration_test_file_url: null,
    next_penetration_test_date: null,
    // 列表列才有的鍵
    cve_risk_level: "高",
    cve_count: 1,
    kev_risk_level: "高",
    kev_count: 1,
    mock_only: {
      scanFiles: [],
      scanRows: [],
      pentestFiles: [],
      pentestRows: [],
      deployedHardwareIds: [],
      ports: [],
      approvalStatus: "approved",
    },
  },
];
